import styled from "styled-components";
import { COLOUR_CONSTANT } from "../../../utils/contants";

export const MilestonesStyled = styled.div`
  .deliv-header-fixed-deliv {
    width: 100%;
    display: grid;
    grid-template-columns: 0.6fr 0.4fr;
    gap: 16px;

    .deliverable-name {
      display: flex;
      width: 100%;
      .delete {
        align-self: end;
      }
    }

    .dummyField {
      display: grid;
      grid-template-columns: 0.7fr 0.3fr;
      width: calc(100% - 16px);
      gap: 16px;
      align-items: center;
    }
  }
  .deliv-header-fixed-project {
    width: 100%;
    display: flex;
    align-items: end;
  }
  .grid-task {
    width: 100%;
    display: grid;
    gap: 16px;
    grid-template-columns: 1.5fr 0.5fr;
  }

  .name-duration-task {
    display: grid;
    grid-template-columns: 1.5fr 1.1fr 0.4fr;
    gap: 16px;
    align-items: center;
  }

  .ant-picker {
    width: 100%;
  }

  .grid {
    width: 100%;
    display: grid;
    gap: 16px;
    grid-template-columns: 1.5fr 0.5fr;
  }

  .name-duration {
    display: grid;
    grid-template-columns: 1.25fr 0.75fr;
    gap: 16px;
  }

  .name {
    display: flex;
    width: 100%;
    button {
      padding: 6px;
      display: flex;
      align-items: end;
    }
    .delete {
      align-self: end;
    }
  }
  .dummyField {
    display: flex;
    gap: 16px;

    /* gap: 16px;
      align-items: flex-end;
      width: 280px;
      min-width: 280px; */
  }

  .milestone-body {
    .drag {
      background-color: #f6f6fe !important;
    }
  }

  .no-pointer-events {
    pointer-events: none;
  }
  .opacity {
    opacity: 0.7;
  }
  .opacity-5 {
    opacity: 0.5;
  }

  .add-task-btn {
    display: flex;
    justify-content: end;
    background-color: ${COLOUR_CONSTANT.theme.purple.light};
    padding: 8px 16px;
  }

  .add-deliv {
    display: flex;
    justify-content: end;
    padding: 16px 0;
  }
`;

export const MilestonesListStyled = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  background-color: #f6f6fe;
  padding: 12px 16px;

  .services {
    display: flex;
    justify-content: space-between;
  }
  .services-fixed {
    display: flex;
    justify-content: space-between;

    .field {
      display: flex;
      gap: 16px;
    }

    .subfield {
      display: flex;
      gap: 8px;
      align-items: center;
    }

    .label {
      white-space: nowrap;
    }
  }
`;
